import { Injector } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { AuthorisedSubstance } from "../../../Data/Art57Data/AuthorisedSubstance";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { TreeNodeSubstanceTranslationList } from "../ListEntity/TreeNodeSubstanceTranslationList";
import { TreeNodeSubstanceAliasList } from "../ListEntity/TreeNodeSubstanceAliasList";
import { TreeNodeSubstanceInternationalCodeList } from "../ListEntity/TreeNodeSubstanceInternationalCodeList";
import { TreeNodeSubstanceParentCodeFieldsList } from "../ListEntity/TreeNodeSubstanceParentCodeFieldsList";
import { TreeNodeSubstancePreviousEvCodeFieldsList } from "../ListEntity/TreeNodeSubstancePreviousEvCodeFieldsList";
import { TreeNodeSubstanceAttachmentFieldsList } from "../ListEntity/TreeNodeSubstanceAttachmentFieldsList";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeApprovedSubstance extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new AuthorisedSubstance(
          new FieldDefinition(injector),
          new FormGroup({}),
          {}
        ),
        '{param1} - Approved{param2}{param3}'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Approved Substance';
      this.data.model.operationtype = 1;
    // localnumber is calculated in createchiltemplate of its parent because requires nodetype
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      const param1 = this.ioc!.get(LookupGetService).retrieveValueFromCache('operationtype',this.data.model.operationtype);
      const param2 = this.data.model && this.data.model.operationtype && this.data.model.operationtype === 1?'':' - ' + this.data.model.ev_Code;
      let param3 = '';
  
      if (this.data && this.data.model && this.data.model.substancename) {
        param3 = ' - ' + this.data.model.substancename;
      }

      this.label = this.labelTemplate
        .replace('{param1}', param1)
        .replace('{param2}', param2)
        .replace('{param3}', param3);

    }
  
    override getMessage(): any {
      //Authorised substance level
      let approvedsubstance: any = {};
  
      if (this.data.model) {
        approvedsubstance = { ...this.data.model };
      }
  
      //Authorised product children
      let childrenModel: any = {};
      this.children?.forEach((node) => {
        let authorisedSubstanceChild = node as Art57Node;
        let art57Message = authorisedSubstanceChild.getMessage();
        if (art57Message != null) {
          childrenModel = { ...childrenModel, ...art57Message };
        }
      });
  
      if (childrenModel) {
        approvedsubstance = { ...approvedsubstance, ...childrenModel };
      }
  
      return approvedsubstance;
    }
  
    override setMessage(jsonObject: any): void {
      super.setMessage(jsonObject);
  
      //TODO: Implement Childrens
      
      // Import Children Nodes
      if (jsonObject.substancetranslations) {
        Art57NodeUtils.importNodeType(this,jsonObject.substancetranslations, 'substancetranslation',TreeNodeSubstanceTranslationList);
      }

      if (jsonObject.substancealiases) {
        Art57NodeUtils.importNodeType(this,jsonObject.substancealiases, 'substancealias',TreeNodeSubstanceAliasList);
      }

      if (jsonObject.internationalcodes && jsonObject.internationalcodes.internationalcode) {

        const internationalCodes = jsonObject.internationalcodes.internationalcode.filter((code: any) => {
          return !code.referencetext || !code.referencetext.resolutionmode ||code.referencetext.resolutionmode == null;
        });
        
        const internationalcodeJSON = {
          internationalcodes: {
            internationalcode: internationalCodes
          }
        };
        if (internationalcodeJSON) {
          Art57NodeUtils.importNodeType(this,internationalcodeJSON.internationalcodes, 'internationalcode',TreeNodeSubstanceInternationalCodeList);
        }

        const substanceParentCodes = jsonObject.internationalcodes.internationalcode.filter((code: any) => {
          return code.referencetext && code.referencetext.resolutionmode && code.referencetext.resolutionmode != null;
        });
        
        const substanceParentCodesJSON = {
          internationalcodes: {
            internationalcode: substanceParentCodes
          }
        };

        if (substanceParentCodesJSON) {
          Art57NodeUtils.importNodeType(this,substanceParentCodesJSON.internationalcodes, 'internationalcode',TreeNodeSubstanceParentCodeFieldsList);
        }
      }

      if (jsonObject.previousevcodes) {
        Art57NodeUtils.importNodeType(this,jsonObject.previousevcodes, 'previousevcode',TreeNodeSubstancePreviousEvCodeFieldsList);
      }

      if (jsonObject.substanceattachments) {
        Art57NodeUtils.importNodeType(this,jsonObject.substanceattachments, 'substanceattachment',TreeNodeSubstanceAttachmentFieldsList);
      }

      this.refreshLabel();
        
    }

    override getListItem(): any[] {
      return [
        this.data.model && this.data.model.ev_Code
        ? this.data.model.ev_Code
        : '-',
        this.data.model &&
        this.data.model.operationtype &&
        this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'operationtype',
          this.data.model.operationtype
        ),
        this.data.model &&
        this.data.model.operationtype &&
        this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'substancestypes',
          this.data.model.type
        ),
        this.data.model && this.data.model.substancename
          ? this.data.model.substancename
          : '',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeApprovedSubstance = new TreeNodeApprovedSubstance(
        this.ioc!,
        newParent
      );
  
      const currentLocalNumber = this.ioc!.get(LookupGetService).getNodeLocalNumber(clonedNode, this);
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.data.model.localnumber = currentLocalNumber;
      this.ioc!.get(LookupGetService).fixLocalNumber(clonedNode.data.model.localnumber);

      clonedNode.refreshLabel;
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];
      
      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
  }